import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PopoverController, LoadingController, AlertController, MenuController } from '@ionic/angular';
import { ServicioService } from 'src/app/services/servicio.service';
import { FlagsPage } from 'src/app/pages/flags/flags.page';
import { Router } from '@angular/router';

@Component({
  selector: 'app-flags',
  templateUrl: './flags.component.html',
  styleUrls: ['./flags.component.scss'],
})
export class FlagsComponent implements OnInit {
  @ViewChild('flag', { static: true }) bandera: ElementRef;

  hasData = false;
  items: any = [];
  productos: any = [];
  productRows: any;

  cartItems: any[];
  public countCart = 0;

  searchVisible = false;

  public pais = 'co';
  public flag = '';
  public visible = true;

  constructor(
    private popoverCtrl: PopoverController,
    private service: ServicioService,
    private router: Router
  ) {

    this.items = [];
    this.productos = [];
    this.productRows = null;

  }

  ngOnInit() {

    this.service.getObservableCountry().subscribe((data) => {
      this.actualizarPais();
    });

    this.actualizarPais();
  }

  public async actualizarPais() {
    this.service.getVariable('pais').then(async res => {
      this.pais = res;

      if (this.pais === null) {
        this.pais = 'co';
      }

      this.flag = '/assets/flags/' + this.pais + '.svg';

    });
  }
  async escogerPais(ev: any) {
    const popover = await this.popoverCtrl.create({
      component: FlagsPage,
      cssClass: 'my-custom-class',
      event: ev,
      translucent: true
    });

    popover.onDidDismiss().then(async res => {

      if (res.data !== undefined) {
        if (res.data) {

          await this.service.setVariable('pais', res.data);

          if (res.data === 'co') {
            res.data = '';
          }

          await this.service.publishCountryData({
            ev: 'changePais'
          });

          await this.router.navigateByUrl('/home/' + res.data, { replaceUrl: true });
          await this.router.navigateByUrl('/select/' + res.data);
          
          window.location.reload();
          

        }
      }
    });
    return await popover.present();
  }

}
